import React, { useState } from 'react';
import { useTutorial } from '../../../contexts/TutorialContext';
import './Tutorial.css';

interface TutorialHelpButtonProps {
  pageKey: string;
  className?: string;
  showOnlyWhenCompleted?: boolean;
}

export const TutorialHelpButton: React.FC<TutorialHelpButtonProps> = ({
  pageKey,
  className = '',
  showOnlyWhenCompleted = false,
}) => {
  const {
    startTutorial,
    isPageCompleted,
    isPageDismissed,
    getTutorialForPage,
    isActive,
    loading,
  } = useTutorial();

  const [isHovered, setIsHovered] = useState(false);

  const tutorial = getTutorialForPage(pageKey);
  const completed = isPageCompleted(pageKey);
  const dismissed = isPageDismissed(pageKey);

  // Don't show if no tutorial exists for this page
  if (!tutorial) {
    return null;
  }

  // Don't show while loading
  if (loading) {
    return null;
  }

  // If showOnlyWhenCompleted, hide until user has seen the tutorial
  if (showOnlyWhenCompleted && !completed && !dismissed) {
    return null;
  }

  // Don't show button while tutorial is active
  if (isActive) {
    return null;
  }

  const handleClick = () => {
    startTutorial(pageKey);
  };

  return (
    <button
      className={`tutorial-help-button ${className}`}
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      title={`View ${tutorial.title} tutorial`}
      aria-label={`Start tutorial for ${tutorial.title}`}
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="10"
          cy="10"
          r="9"
          stroke="currentColor"
          strokeWidth="1.5"
          fill={isHovered ? 'currentColor' : 'none'}
        />
        <text
          x="10"
          y="14"
          textAnchor="middle"
          fill={isHovered ? 'white' : 'currentColor'}
          fontSize="12"
          fontWeight="600"
        >
          ?
        </text>
      </svg>
      <span className="tutorial-help-button__text">Help</span>
    </button>
  );
};

export default TutorialHelpButton;
